module.exports = __webpack_public_path__ + "img/eye.cfe3f50c.svg";